var _title, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgBookings = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Bookings")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/filled/bookings",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1666667,10.1666666 L40.5,10.1666666 C41.0522847,10.1666666 41.5,10.6143819 41.5,11.1666666 L41.5,40.5 C41.5,41.0522848 41.0522848,41.5 40.5,41.5 L7.49999996,41.5 C6.94771521,41.5 6.49999996,41.0522848 6.49999996,40.5 L6.49999996,11.1666666 C6.49999996,10.6143819 6.94771521,10.1666666 7.49999996,10.1666666 L13.8333333,10.1666666 L13.8333333,7.49999996 C13.8333333,6.94771521 14.2810486,6.49999996 14.8333333,6.49999996 C15.3856181,6.49999996 15.8333333,6.94771521 15.8333333,7.49999996 L15.8333333,10.1666666 L32.1666667,10.1666666 L32.1666667,7.49999996 C32.1666667,6.94771521 32.6143819,6.49999996 33.1666667,6.49999996 C33.7189514,6.49999996 34.1666667,6.94771521 34.1666667,7.49999996 L34.1666667,10.1666666 Z M39.5,17.5 L39.5,12.1666666 L8.49999996,12.1666666 L8.49999996,17.5 L39.5,17.5 Z M39.5,19.5 L8.49999996,19.5 L8.49999996,39.5 L39.5,39.5 L39.5,19.5 Z",
    id: "Shape",
    fill: "#0A1428",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D8F1EC",
    fillRule: "nonzero",
    points: "39.5 17.5 39.5 12.1666666 8.49999996 12.1666666 8.49999996 17.5"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBookings, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bookings.69b857e7.svg";
export { ForwardRef as ReactComponent };